import { useEffect } from 'react';
import { GetServerSideProps } from 'next';

import AuthoredPageRoutes from '@/components/authored-page-routes/authored-page-routes';
import { BFF_PATH, PLP_PAGE_TYPE } from '@/data/constants';
import { PreRenderProps } from '@/pages/_app';
import { getPlpViewDefinition } from '@/ssr/view-definition-plp-page-query';

import { fetchDataAndHandleErrors, withTokenRefresh, measureDuration } from '@/utils/ssr-utils';
import { collectMetrics, getFullPath, ANALYTICS_EVENT_NAMES, type IApiTiming } from '@iceberg/report-perfect-experience-analytics';
import { getKeyIdFromUrl } from '@/utils';
import { ANALYTICS_PAGE_NAMES, ERROR_STATUS_CODE, SUCCESS_STATUS_CODE } from '@/utils/analytics/constants';

export const getServerSideProps: GetServerSideProps<PreRenderProps> = withTokenRefresh(async (context: any) => {
  const { result: data, duration: ssrFetchDurationMs } = await measureDuration(() => fetchDataAndHandleErrors(context, getPlpViewDefinition, PLP_PAGE_TYPE.BRAND));

  const hasBackendFetchData = Boolean(
    data && Object.keys(data).length,
  );
  const { resolvedUrl } = context;
  const keyId = getKeyIdFromUrl(resolvedUrl);
  const ssrFetchData: IApiTiming = {
    name: `POST ${BFF_PATH.BRAND}${keyId}`,
    duration: ssrFetchDurationMs,
    status: Number(hasBackendFetchData ? SUCCESS_STATUS_CODE : ERROR_STATUS_CODE),
  };

  return {
    props: {
      ...data,
      ssrFetchData,
    },
  };
});

const BrandPlpRoutes = (props: any) => {
  collectMetrics(ANALYTICS_EVENT_NAMES.PAGE_INIT, {
    detail: {
      page_name: getFullPath()
    }
  });
  useEffect(() => {
    collectMetrics(ANALYTICS_EVENT_NAMES.PAGE_READY, {
        detail: {
          page_name: getFullPath(),
          page_id: ANALYTICS_PAGE_NAMES.PLP,
        }
      }); 
  }, []);
  return (
    <AuthoredPageRoutes pageType={PLP_PAGE_TYPE.BRAND} {...props} />
  );
};

export default BrandPlpRoutes;
